import { createAction, props } from '@ngrx/store';

import { GoogleAnalyticsConfiguration, GoogleAnalyticsEvent } from './google-analytics.models';

export const initialize = createAction('[Tracking][GA4] Initialize', props<GoogleAnalyticsConfiguration>());
export const push = createAction(
  '[Tracking][GA4] DataLayer push',
  props<GoogleAnalyticsEvent & { title_context?: string; enriched?: boolean }>()
);
export const setPreviousUrl = createAction('[Tracking][GA4] Set previous url', props<{ url?: string }>());
